<button type="button" uppDataid="stripe-pay-button"
    [disabled]="disabled"
    (click)="OnPay()">
    <img [src]="iconSrc" alt="stripe">
    <span class="upp-stripe-pay-button-label">
        {{tr(titleKey)}}<br/>
        <span class="small" *ngIf="subtitleKey">{{tr(subtitleKey)}}</span>
    </span>
</button>
